/*-----------------------------------------------------------------
- Dashboard trans
-----------------------------------------------------------------*/
export default {
    transactions: {
        row            : 'ردیف',
        title          : 'عنوان',
        date           : 'تاریخ',
        claimed_at     : 'تاریج ایجاد',
        confirmed_at   : 'تاریخ تایید',
        path           : 'مسیر پرداخت',
        gateway        : 'درگاه پرداخت',
        amount         : 'مبلغ',
        type           : 'نوع پرداخت',
        method         : 'روش پرداخت',
        status         : 'وضعیت',
        tracking_number: 'شماره پیگیری',
        online         : 'آنلاین',
        offline        : 'آفلاین',
    },
};
